import ScrollReveal from 'scrollreveal'

ScrollReveal().reveal('[data-sr-fade-up]', {
  distance: '125%',
  origin: 'bottom',
  interval: 100,
})

ScrollReveal().reveal('[data-sr-fade-down]', {
  distance: '125%',
  origin: 'top',
  interval: 100,
})

ScrollReveal().reveal('[data-sr-fade-left]', {
  distance: '125%',
  origin: 'right',
  interval: 100,
})

ScrollReveal().reveal('[data-sr-fade-right]', {
  distance: '125%',
  origin: 'left',
  interval: 100,
})

ScrollReveal().reveal('[data-sr-fade]', {
  interval: 100,
})

ScrollReveal().reveal('[data-sr-zoom-in]', {
  scale: 0.85,
  interval: 100,
})
